var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 25.216,
    fill: "#00ADEF",
    rx: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.111 13.56L12.961 9h-2.61v6.472L7.278 9h-2.15l-3.072 6.767H3.9l.614-1.471h3.38l.613 1.47h3.533v-5l2.303 5h1.536l2.304-4.854v4.855h1.69v-6.62h-2.611l-2.15 4.56v-.147zm-8.907-.735H5.129l1.075-2.354 1.075 2.207-1.075.147zm24.419-.442l1.229 1.324 1.842 2.06h-2.15l-1.996-2.207-1.997 2.207h-6.604v-6.62h6.604l1.997 2.06 1.996-2.06h2.15l-1.842 1.912-1.23 1.324zm-4.147 2.06l1.997-2.06-1.997-1.765h-3.84v1.177h3.84v1.324h-3.84v1.324h3.84z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.8d8a14f991e5e15149be1d160d391622.svg";
export { ForwardRef as ReactComponent };